import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Central hook for fetching subsidiaries from the API.
// Also exposes a `refresh()` used by admin CRUD after mutations.
export function useSubsidiaries() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/subsidiaries");
      setSubs(data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { subs, loading, error, refresh };
}
